export const PLACEMENT_MAP: Record<string, string> = {
  left: 'bottom-start',
  right: 'bottom-end',
  center: 'bottom',
};